<template>
    <el-dialog title="任务日志" width="70%" height="100%" :visible.sync="dialogLogVisible" :close-on-click-modal="false" @open="open()">
        <div style="margin-bottom:5px">
            <el-date-picker
            v-model="start_time"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            type="datetime"
            placeholder="开始日期">
            </el-date-picker>
            <el-date-picker
            v-model="end_time"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期">
            </el-date-picker>
            <el-button @click="select" size="small" :loading="isaveing">查询</el-button>
        </div>
        <el-table :data="taskLog" width="100%" height="200"  border>
            <el-table-column
                prop="tasktime"
                label="执行时间"
                width="160">
            </el-table-column>
            <el-table-column
                prop="taskstate"
                label="执行状态"
                width="80">
            </el-table-column>
            <el-table-column
                prop="taskmessage"
                label="执行消息"
               >
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-sizes="[20,50,100,200]"
            :page-size.sync="pageSize"
            layout="total,sizes, prev, pager, next"
            :total="logTotal">
        </el-pagination>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogLogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogLogVisible = false">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import Utility from '@/components/mixin.js'
import axios from 'axios'
export default {
    mixins: [Utility],
    props:{
        taskData:Object
    },
    data () {
        return {
            dialogLogVisible:false,
            taskLog:[],//任务日志
            logTotal:0,
            start_time:this.localdate()+" 00:00:00",
            end_time:this.localdate()+" 23:59:59",
            currentPage1:1,
            pageSize:20,//当前页面大小
            isaveing:false
        }
    },
    mounted(){
        // this.taskLog=[
        //     {tasktime:'2021-1-1',taskstate:'开始',taskmessage:'1111'},
        //     {tasktime:'2021-1-1',taskstate:'开始',taskmessage:'1111'},
        //     {tasktime:'2021-1-1',taskstate:'开始',taskmessage:'1111'},
        //     {tasktime:'2021-1-1',taskstate:'开始',taskmessage:'1111'}
        // ]
        //this.logTotal= this.taskLog.length
    },
    methods:{
        select(){
            this.initData(this.taskData.taskid,this.usrinfo.token,this.start_time,this.end_time)
        },
        open(){
           this.initData(this.taskData.taskid,this.usrinfo.token,this.start_time,this.end_time)
        },
        initData(taskid,ptoken,start_time,end_time){
           axios.get('/mananger/task/log?taskid='+taskid+'&start_time='+start_time+'&end_time='+end_time+'&pageidx='+this.currentPage1+'&pagesize='+this.pageSize+'&token=' + ptoken)
            .then(response => {
            let res = response.data
            console.log(res)
            if(res.code === 1){
                console.log(res.data)
                this.taskLog = res.data
                this.logTotal= this.taskLog.length
            }else{
                 this.err_process(res.code, '[' + res.code + ']' + res.message)
            }
            })
            .catch(err => {
              console.error(err)
              this.err_process('AAAA', '获取数据异常:[AAAA]' + err)
            })
        },
          //当前页号发生改变
        handleCurrentChange(){
            console.log(this.pageSize,this.currentPage1);
            this.initData(this.taskData.taskid,this.usrinfo.token,this.start_time,this.end_time)
        },
        //页面大小发生改变
        handleSizeChange(){
            console.log(this.pageSize,this.currentPage1);
            this.initData(this.taskData.taskid,this.usrinfo.token,this.start_time,this.end_time)
        },
    }
}
</script>
<style scoped>
>>>.el-dialog__body {
    padding: 10px 20px;
}
</style>